'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var propTypes = {
	auto: {
		type: 'boolean'
	},
	height: {
		type: 'string'
	},
	onClickOutside: {
		type: 'function'
	},
	open: {
		type: 'boolean'
	},
	width: {
		type: 'string'
	}
};

var defaultProps = {
	height: 500,
	width: 500
};

var handleClickOutside = function handleClickOutside(onClickOutside) {
	return function (e) {
		return onClickOutside && e.delegateTarget === e.target && onClickOutside();
	};
};

var afterMount = function afterMount(_ref, el, setState) {
	var props = _ref.props,
	    state = _ref.state;
	var open = props.open;


	if (open) {
		setState({ open: true });
	}
};

var afterUpdate = function afterUpdate(_ref2, prevProps, prevState, setState) {
	var props = _ref2.props;

	if (!props.open && (prevProps.open || prevState.open)) {
		setState({ open: false });
	}

	if (props.open && (!prevProps.open || !prevState.open)) {
		setState({ open: true });
	}
};

var afterRender = function afterRender(_ref3, el) {
	var props = _ref3.props;
	var auto = props.auto,
	    height = props.height,
	    width = props.width;


	if (auto) {
		return;
	}

	var popup = el.children[0];

	popup.style.height = height;
	popup.style.width = width;
};

var shouldUpdate = function shouldUpdate(_ref4, nextProps, _ref5) {
	var props = _ref4.props,
	    state = _ref4.state;
	var open = _ref5.open;
	return !(0, _deepEqual2.default)(props, nextProps) || state.open !== open;
};

var render = function render(_ref6) {
	var props = _ref6.props,
	    state = _ref6.state;
	var children = props.children,
	    onClickOutside = props.onClickOutside,
	    styleClasses = props.styleClasses;
	var open = state.open;

	var overlayClasses = {
		Overlay: true,
		'is-open': open
	};

	var overlay = ['position: fixed', 'z-index: 9999', 'top: 0', 'right: 0', 'bottom: 0', 'left: 0', 'width: 100%', 'height: 100%', 'justify-content: center', '-webkit-justify-content: center', 'align-items: center', '-webkit-align-items: center'];

	var flex = open ? ['display: flex', 'display: -webkit-flex', 'display: -ms-flexbox'] : ['display: none'];
	var overylayStyles = overlay.concat(flex).join(';');

	var popupClasses = {
		'is-open': open,
		Popup: !styleClasses || styleClasses && !styleClasses.Popup
	};

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': overlayClasses, style: overylayStyles, onClick: handleClickOutside(onClickOutside) },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': [popupClasses, props.class, styleClasses && styleClasses.Popup], style: styleClasses && styleClasses.Popup && ['overflow: scroll'], 'data-style-attr': 'Popup' },
			children
		)
	);
};

exports.default = { afterMount: afterMount, afterRender: afterRender, afterUpdate: afterUpdate, defaultProps: defaultProps, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };
